import request from '@/utils/changanRequest'
export function addEmployment(data) {
  return request({
    url: '/system/employment',
    method: 'post',
    data: data
  })
}

// 查询招聘求职详细
export function getEmployment(query) {
  return request({
    url: '/system/employment/details',
    method: 'get',
    params: query
  })
}
// 查询商家求职详细
export function merchantJobPosting(id) {
  return request({
    url: '/system/merchantJobPosting/wechat/'+id,
    method: 'get',
  })
}
